import isUrl from 'is-url';
import { getEventTransfer } from 'slate-react';
import 'whatwg-fetch';

const twitter = {
  widget: 'https://platform.twitter.com/widgets.js',
  domain: 'https://twitter.com',
};

/**
 * Injects twitter's widget script into body if not already there.
 */
function injectWidgetScript() {
  if (document.getElementById('twitter-widget-script')) return;
  const script = document.createElement('script');
  script.setAttribute('src', twitter.widget);
  script.setAttribute('async', true);
  script.setAttribute('id', 'twitter-widget-script');
  script.setAttribute('onload', 'twttr.widgets.load()');
  document.body.appendChild(script);
};

export default function embedTweet(options) {
  injectWidgetScript();
  return {
    onPaste(event, change, editor) {
      const transfer = getEventTransfer(event);
      const { text, type } = transfer;

      // If pasting anything that's not text or html, fall through.
      if (type !== 'text' && type !== 'html') return;
      // If not a tweet, fall through.
      if (!this.isTweet(text)) return;

      this.handleTweet(text, change, editor);
    },

    /**
     * Check if there are blockquotes that need to be replaced as early
     * as possible in editor.
     */
    onKeyUp() {
      this.replaceBlockquotes();
    },

    /**
     * Check if text is a URL and is from Twitter.
     */
    isTweet(text) {
      if (!isUrl(text)) return false;
      if (text.indexOf(twitter.domain) > -1) return true;
      return false;
    },

    /**
     * Adds a temporary loading spinner and then adds correct state for
     * tweet once fetched from oEmbed endpoint.
     */
    async handleTweet(url, change, editor) {
      const tempState = change.insertBlock({
        type: 'loading-spinner',
        isVoid: true,
      });

      editor.onChange(tempState);

      const data = await this.fetchOembed(url);

      const newState = change.undo().delete().insertBlock({
        type: 'tweet',
        isVoid: true,
        data: data,
      }).insertBlock('paragraph');

      editor.onChange(newState);
      this.replaceBlockquotes();
    },

    /**
     * Grab oEmbed data from our endpoint. Excluding script, which is injected.
     */
    async fetchOembed(url) {
      const response = await fetch(options.oembedAPI, {
        method: 'POST',
        headers: {
          'Authorization': options.authorization || '',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          url: url,
          omit_script: 't',
        }),
      });

      const data = await response.json();
      return data;
    },

    /**
     * Replaces twitter blockquotes with rendered embeds.
     */
    replaceBlockquotes() {
      const rawTweets = document.querySelectorAll('blockquote.twitter-tweet');
      if (rawTweets.length === 0) return;
      window.twttr.widgets.load();
    },
  };
}
